import { handleKeywordForSearch, initFilterSelect } from "@/utils/mall/mall";
import { Action, Module, Mutation } from "vuex-module-decorators";
import { ProductFilterKeysEnums } from "@/enums/product";
import { RootState } from "@/store";
import type { PaginationDataState } from "@/types";
import PaginationModule from "@/store/base-modules/PaginationModule";
import { queryRequest } from "@/utils/request";
import {
  searchCatalogProductList,
  getTBRAttrData,
  addCart
} from "@/graphql/product.gql";
import { getCartSkuAmount } from "@/graphql/cart.gql";
import { GTGroupFixedOrgParam, GTGroupTBRFixedParam } from "@/enums/app";
import { getAttributes, getAttrName } from "@/utils/mall/mall";

export interface IMallProductListState extends PaginationDataState {
  listData: any[];
  searchCondition: any;
  sizeData: any;
  TBRSearchCondition: any;
}

export interface MallProductSearchCondition {
  productName: string;
}

//默认搜索条件
const defaultSearchCondition = (): MallProductSearchCondition => ({
  productName: ""
});

@Module({ name: "MallProductListModule", namespaced: true })
export default class MallProductListModule
  extends PaginationModule<IMallProductListState, RootState>
  implements IMallProductListState {
  // 列表数据
  listData: any[] = [];
  // 搜索条件
  searchCondition: MallProductSearchCondition = defaultSearchCondition();
  // 搜索尺寸元数据
  sizeData = [];
  // 加入购物车中
  addingCart: boolean = false;
  // 活动popup
  activityPopup: boolean = false;
  // sku是否支持快递映射表
  skuExpressMap: any = {};
  //活动类型
  productType: string = "";
  //page plp
  skuPagePLPExpressMap: any = "";

  //筛选数据
  TBRSizeData: any = {};
  //筛选条件
  TBRSearchCondition: MallProductSearchCondition = defaultSearchCondition();
  // 购物车数量
  cartNumber: number = 0;
  @Mutation
  saveCartNumberMutation(data: number | undefined | null) {
    this.cartNumber = data ?? 0;
  }
  @Mutation
  saveTBRSearchConditionMutation(data = defaultSearchCondition()) {
    this.TBRSearchCondition = data;
  }
  @Mutation
  saveProductTypeMutation(data: string) {
    this.productType = data || "";
  }
  @Mutation
  saveListDataMutation(data = []) {
    console.log(69, data);
    this.listData = data;
  }
  @Mutation
  addListDataMutation(data = []) {
    this.listData.push(...data);
  }

  @Mutation
  saveTBRSizeDataMutation(data = []) {
    this.TBRSizeData = data || [];
  }
  @Mutation
  saveSearchConditionMutation(data = defaultSearchCondition()) {
    this.searchCondition = data;
  }

  @Mutation
  saveAddingCartMutation(data: boolean) {
    this.addingCart = data || false;
  }
  @Mutation
  saveActivityPopupMutation(data: boolean) {
    this.activityPopup = data || false;
  }

  @Mutation
  saveSkuExpressMapMutation(data = {}) {
    this.skuExpressMap = Object.assign({}, this.skuExpressMap, data);
  }
  @Mutation
  saveSkuPagePLPExpressMapMutation(data = {}) {
    this.skuPagePLPExpressMap = Object.assign({}, this.skuExpressMap, data);
  }
  @Mutation
  clearSkuPagePLPExpressMapMutation() {
    this.skuPagePLPExpressMap = {};
  }
  // 获取商品列表 TBR
  @Action
  async initListAction() {
    let {
      state: {
        paginationData: { pageNum, pageSize },
        TBRSearchCondition
      }
    } = this.context;

    let {
      dataList = [],
      pageInfo: { totalCount }
    } = await queryRequest({
      query: searchCatalogProductList,
      variables: {
        input: {
          ...TBRSearchCondition
        },
        pageInput: { pageNum, pageSize }
      }
    });
    let {
      commit,
      state: { paginationData }
    } = this.context;
    console.log(132, dataList);
    dataList = dataList.map(item => item.data).filter(Boolean);
    console.log(134, dataList);
    commit(
      paginationData.pageNum === 1
        ? "saveListDataMutation"
        : "addListDataMutation",
      dataList
    );
    // 保存总数
    console.log(paginationData, totalCount);
    commit("savePaginationData", { ...paginationData, totalCount });
  }

  @Action
  searchAction() {
    this.context.commit("saveListDataMutation");
    this.paginationData.pageNum = 1;
    this.context.dispatch("initListAction");
  }

  // 获取筛选数据
  @Action
  async getFilterDataAction() {
    const data = await queryRequest(
      {
        query: getTBRAttrData,
        variables: {}
      },
      { custom: true }
    );
    data.pattern = data.pattern.map(i => {
      return {
        value: i,
        _select: false
      };
    });

    console.log(175, data);
    const { commit } = this.context;

    commit("saveTBRSizeDataMutation", data);
  }

  // 重置排序
  @Action
  resetSortAction() {
    Object.keys(this.searchCondition).map(key => {
      if (~key.indexOf("Sort")) {
        this.searchCondition[key] = void 0;
      }
    });
    // this.searchCondition = cloneDeep(this.searchCondition);
  }

  // 添加购物车
  @Action
  async addCartAction({ productNo = "", count = 1 } = {}) {
    const { success } = await queryRequest({
      query: addCart,
      variables: {
        input: {
          productNo,
          count,
          ...GTGroupTBRFixedParam
        }
      }
    });
    // 添加购物车需要更新购物车数量
    this.context.dispatch("getCartSkuAmountAction");
    return success;
  }

  // 查询购物车数量
  @Action
  async getCartSkuAmountAction() {
    const { amount = 0 } = await queryRequest({
      query: getCartSkuAmount,
      variables: {
        // ...GTGroupFixedParam
      }
    });
    this.context.commit("saveCartNumberMutation", amount);
  }
}
